import BellIcon from 'transfix-icons/build/BellIcon'
import FilterIcon from 'transfix-icons/build/FilterIcon'
import PriceIcon from 'transfix-icons/build/PriceIcon'
import SearchIcon from 'transfix-icons/build/SearchIcon'
import { IPopularToolButton } from './types'

export const POPULAR_TOOLS_LINKS: IPopularToolButton[] = [
  {
    title: 'Manage Bids',
    Icon: PriceIcon,
    event: 'HOME_POPULAR_TOOLS_CLICKED_MANAGE_BIDS',
    link: '/bids',
  },
  {
    title: 'Find Loads',
    Icon: SearchIcon,
    event: 'HOME_POPULAR_TOOLS_CLICKED_FIND_LOADS',
    link: '/book',
  },
  {
    title: 'Add Saved Lane',
    Icon: BellIcon,
    event: 'HOME_POPULAR_TOOLS_CLICKED_ADD_SAVED_LANE',
    link: '/transfix-lanes/add-alert',
  },
  {
    title: 'Carrier Preferences',
    Icon: FilterIcon,
    event: 'HOME_POPULAR_TOOLS_CLICKED_CARRIER_PREFERENCES',
    link: '/user/settings/carrier-profiles',
  },
]
